import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as CornerUpLeftIcon } from './cornerUpLeft.svg';

export const CornerUpLeft = IconHOC(CornerUpLeftIcon);
